import { useState, useEffect } from 'react';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';

import ButtonBase from '../../../../components/@extended/ButtonBase';
import { useTranslation } from 'react-i18next';
import LanguageIcon from '@mui/icons-material/Public';


const languages = [
  { code: 'es', label: 'Español' },
  { code: 'en', label: 'English' }
];

export default function Language() {
  const { i18n, t } = useTranslation();
  const [current, setCurrent] = useState<string>(localStorage.getItem('lang') || i18n.language || 'en');
  useEffect(() => {
    if (i18n.language !== current) {
      i18n.changeLanguage(current);
    }
  }, [current, i18n]);
  const toggleLang = () => {
    const next = current === 'en' ? 'es' : 'en';
    setCurrent(next);
    localStorage.setItem('lang', next);
    i18n.changeLanguage(next);
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 0.75 }}>
      <Tooltip title={`${t('language')}: ${current.toUpperCase()}`}>
        <ButtonBase
          color="secondary"
          variant="light"
          sx={(t: any) => ({
            p: 0.2,
            pl: 1.5,
            pr: 1.5,
            height: 44,
            color: 'primary.main',
            bgcolor: 'transparent',
            borderRadius: 1.5,
            display: 'flex',
            alignItems: 'center',
            gap: 0.6,
            transition: 'background-color 150ms ease, color 150ms ease',
            '&:hover': {
              bgcolor: alpha((t as any).palette.primary.light, 0.15),
              ...(t.applyStyles && t.applyStyles('dark', { bgcolor: alpha((t as any).palette.primary.dark, 0.2) }))
            },
            ...(t.applyStyles && t.applyStyles('dark', { bgcolor: 'transparent' }))
          })}
          aria-haspopup="true"
          aria-label="toggle language"
          onClick={toggleLang}
        >
          <LanguageIcon sx={{ fontSize: 30 }} />
          <Box component="span" sx={{ fontWeight: 700, fontSize: 14, letterSpacing: 0.2 }}>{current.toUpperCase()}</Box>
        </ButtonBase>
      </Tooltip>
    </Box>
  );
}


